import { isEmpty } from "lodash";
import { ota_multiFiles } from "../Admin/Firmwares";


export function addFirmware(data) {
    let errors = {};
    let versionRegex = /^(\d+\.)?(\d+\.)?(\*|\d+)$/

    if (!data.firmwareVersion) {
        errors.firmwareVersion = "Firmware version is required"
    }
    if (!data.mcu_version && data.ota_type === "multiple") {
        errors.mcu_version = "MCU version is required"
    }

    if (data.firmwareVersion && !versionRegex.test(data.firmwareVersion)) {
        errors.firmwareVersion = "Invalid firmware version"
    }
    if (data.ota_type === "multiple" && data.mcu_version && !versionRegex.test(data.mcu_version)) {
        errors.mcu_version = "Invalid MCU version"
    }

    if (data.firmwareVersion && versionRegex.test(data.firmwareVersion)) {
        if ((data.firmwareVersion)?.split(".").length < 2 || (data.firmwareVersion)?.split(".").length > 3) {
            errors.firmwareVersion = "Invalid firmware version"
        }
        if (data.ota_type === "multiple" && (data.mcu_version)?.split(".").length < 2 || (data.mcu_version)?.split(".").length > 3) {
            errors.mcu_version = "Invalid MCU version"
        }
        if ((data.firmwareVersion)?.split(".").length === 3) {
            let splitedFirmware = data?.firmwareVersion.split(".")
            for (let i = 0; i < splitedFirmware?.length; i++) {
                if (splitedFirmware[i].length > 3) {
                    errors.firmwareVersion = "Invalid firmware version"
                }
            }
        }
        if (data.ota_type === "multiple" && (data.mcu_version)?.split(".").length === 3) {
            let splitedFirmware = data?.mcu_version.split(".")
            for (let i = 0; i < splitedFirmware?.length; i++) {
                if (splitedFirmware[i].length > 3) {
                    errors.mcu_version = "Invalid MCU version"
                }
            }
        }
    }

    if (!data.fileToUpload.length && data.ota_type === "single") {
        errors.fileToUpload = "Firmware file is required"
    } else if (data.ota_type === "multiple") {
        ota_multiFiles.forEach(item => {
            const isFileExists = data?.fileToUpload?.some(file => file?.key === item.key)
            if (!isFileExists) {
                errors.fileToUpload = { ...(errors.fileToUpload || {}), [item.key]: `${item.label} file is required` }
            }
            const isMd5Exists = data?.fileToUpload?.some(file => file?.hasOwnProperty(item.md_5_Key) && !!file[item.md_5_Key])

            if (!isMd5Exists) {
                errors.fileToUpload = { ...(errors.fileToUpload || {}), [item.md_5_Key]: `${item.label} md5 is required` }
            }
        })
    }

    return {
        isValid: isEmpty(errors),
        errors
    };
}
